import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useLayoutEffect, } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import styled from "@emotion/styled";
import { Fragment } from "react";
import { UI } from "../icons";
import { useElementsContext } from "../elementsProvider";
import { CardCarousel } from "./CardCarousel";
import { colors } from "../theme";
export function SliderCarousel({ colorTexts, products, typographyTexts, isSliderActive, }) {
    const { isMobile, context } = useElementsContext();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [cardWidth, setCardWidth] = useState(0);
    // This number helps the library to get the card width pixel perfect
    const spacing = isMobile ? 8 : 13.3;
    const [sliderRef, slider] = useKeenSlider({
        initial: 0,
        slideChanged(s) {
            setCurrentSlide(s.details().relativeSlide);
        },
        slidesPerView: isMobile ? 2 : 4,
        mode: isMobile ? "free-snap" : "snap",
        spacing,
        centered: isMobile,
        loop: isMobile,
    });
    const sliderSize = products.length;
    useEffect(() => {
        if (slider === null || slider === void 0 ? void 0 : slider.details().size) {
            slider === null || slider === void 0 ? void 0 : slider.resize();
        }
    }, [products, slider]);
    useLayoutEffect(() => {
        if (isMobile) {
            if (context === "editor") {
                // Sets editor's mobile width to calculate de proportional height the card should have
                setCardWidth(320 / 2 - spacing / 2);
            }
            else {
                setCardWidth(document.body.clientWidth / 2 - spacing / 2);
            }
        }
    }, [context, isMobile, spacing]);
    return (_jsx(Fragment, { children: _jsxs(SliderWrapper, Object.assign({ className: "navigation-wrapper", isDesktop: !isMobile, context: context }, { children: [_jsx(Slider, Object.assign({ className: "keen-slider", ref: sliderRef, isDesktop: !isMobile }, { children: products === null || products === void 0 ? void 0 : products.map(subelement => (_jsx(CardCarousel, { subelement: subelement, colorTexts: colorTexts, typographyTexts: typographyTexts, isMobile: isMobile, cardWidth: cardWidth, isSliderActive: isSliderActive, context: context }, subelement.identifier))) }), void 0),
                !isMobile && slider && sliderSize > 4 && (_jsxs(Fragment, { children: [currentSlide === 0 ? null : (_jsx(ArrowLeft, { onClick: e => {
                                e.stopPropagation();
                                slider.moveToSlideRelative(currentSlide - 4);
                            } }, void 0)),
                        currentSlide === sliderSize - 4 ? null : (_jsx(ArrowRight, { onClick: e => {
                                e.stopPropagation();
                                slider.moveToSlideRelative(currentSlide + 4);
                            } }, void 0))] }, void 0))] }), void 0) }, void 0));
}
function ArrowLeft({ onClick }) {
    return (_jsx(Chevron, Object.assign({ className: "arrow arrow--left", onClick: onClick, direction: "left" }, { children: _jsx(UI.Chevron, {}, void 0) }), void 0));
}
function ArrowRight({ onClick }) {
    return (_jsx(Chevron, Object.assign({ className: "arrow arrow--right", onClick: onClick, direction: "right" }, { children: _jsx(UI.Chevron, {}, void 0) }), void 0));
}
const SliderWrapper = styled.div(({ isDesktop, context }) => ({
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: isDesktop ? "94rem" : context === "editor" ? "32rem" : "unset",
    "&:hover .arrow": {
        opacity: 1,
    },
}));
const Slider = styled.div(({ isDesktop }) => (Object.assign({ display: "flex", overflow: "hidden", position: "relative", userSelect: "none", webkitTouchCallout: "none", khtmlUserSelect: "none", msTouchAction: "pan-y", touchAction: "pan-y", webkitTapHighlightColor: "transparent", padding: "0.8rem 2px" }, (isDesktop
    ? {
        margin: "0.8rem 0",
        padding: "0.8rem 2px",
    }
    : {}))));
const Chevron = styled.button(({ direction }) => (Object.assign(Object.assign({ opacity: 0, backgroundColor: colors.white, border: "none", cursor: "pointer", height: "4.4rem", borderRadius: "50%", width: "4.4rem", outline: "none", position: "absolute", boxShadow: " 0 2px 4px 0 rgba(0, 0, 0, 0.09)", textAlign: "center", top: "12.4rem", zIndex: 1000, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }, (direction === "left"
    ? {
        left: "-2.4rem",
        paddingLeft: 2,
    }
    : {
        right: "-1.4rem",
        paddingRight: 2,
    })), { "& svg": {
        color: colors.black,
        fontSize: "1.8rem",
        transform: direction === "left" ? "rotate(90deg)" : "rotate(270deg)",
    } })));
//# sourceMappingURL=SliderCarousel.js.map